const GET_LAT_LONG = '//maps.googleapis.com/maps/api/geocode/json';
const ZERO_RESULTS = 'ZERO_RESULTS';
const QUOTA_EXCEEDED = 'OVER_QUERY_LIMIT';
const GOOGLE_API_KEY = '<!-- @yoda_config google_geocode_key -->';

const egainDomain = {
    dev: 'jcpenney.egain.cloud',
    prod: 'jcpenneyuat.egain.cloud',
    sendEmailAPI: '/ws/v15/context/interaction/activity',
    loginAPI: '/ws/v12/authentication/user/login',
};

export default {
    GET_LAT_LONG,
    ZERO_RESULTS,
    GOOGLE_API_KEY,
    QUOTA_EXCEEDED,
    egainDomain,
};
